export default {
    ORDER_ASC: 'ASC',
    ORDER_DESC: 'DESC',
    DEFAULT_ITEM_FOR_PAGE: 10,
    OPERATOR_JS : {
        'CONTIENE' : 'LIKE',
        'UGUALE' : 'EQUAL',
        'IN' : 'IN',
        'INIZIA_PER' : 'LIKE_START',
        'FINISCE_PER' : 'LIKE_END',
        'MAGGIORE_DI' : 'MAGGIORE',
        'MINORE_DI': 'MINORE',
        'DIVERSO_DA' : 'DIVERSO'
    },
    OPERATOR : {
        CONTIENE:'LIKE',
        IN: 'IN',
        UGUALE: 'EQUAL',
        INIZIA_PER: 'LIKE_START',
        FINISCE_PER: 'LIKE_END',
        MAGGIORE_DI: 'MAGGIORE',
        MINORE_DI: 'MINORE',
        DIVERSO_DA: 'DIVERSO'
    },
    legendStatiPren : {
        confermata:'prenotazione confermata dall\'utente, che deve ancora essere eseguita o è stata eseguita negli ultimi due giorni',
        eseguita:'prestazione già effettuata',
        orario_cambiato:'prenotazione confermata o eseguita per la quale è stato comunicato o dal medico o dal paziente che è stato concordato un diverso appuntamento',
        disdetta:'prenotazione disdetta dal paziente attraverso il sito',
        annullata:'prenotazione annullata a seguito di comunicazione del medico, per indisponibilità del paziente',
        annullata_medico:'prenotazione non effettuata per indisponibilità del medico (es. assenza del medico all\'orario stabilito, mancato aggiornamento dell\'agenda, prestazione non più eseguita, studio non più attivo o altro)',
    },

    FLASH_DATA_STORAGE: -1,

    VIDEOCONSULTO_PRESTAZIONE_ID: 73,
    VIDEOCONSULTO_TIPO_STUDIO: 3,

    TIPO_ORDINE_PROVINCIALE: 1,
    TIPO_ORDINE_REGIONALE: 2,

    SPECIALIZZAZIONE_VALORE_RICHIESTO : 1,
    SPECIALIZZAZIONE_VALORE_OPZIONALE : 2,
    SPECIALIZZAZIONE_VALORE_NON_RICHIESTO : 3,

    method() {

    },
}
